import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import Loadingcontainer from './loadingcontainer';
import Drilldownplaceholder from './drilldownplaceholder';

import { generateExcel } from '../utils/services';

import { updateAppState, updateComponentState } from '../actions/actions';

import {DateElement,LocalSelect,SelectAsync,DateRangeField,AutoSelect,AutoSuggest} from './utils/utilcomponents';

import uuid from 'uuid';

const functionalstatusArray = ['Functional','Partially Functional', 'Non-Functional', 'Proposed for condemnation', 'Not found', 'Reimbursable','Others','Not in use','Judiciary'];

const contractstatusArray = ['Service Provider','Warranty / AMC','CAMC','Rental','Out of Warranty/AMC'];



const departmentArray = ["3 OT","Anaesthesiology","Anatomy","Artificial Kidney Dialysis","Audiology","Autoclave Room","B-BLOCK","Biochemistry","Biochemistry E.Lab","Blood Bank","Burn OT","Burns Ward 2","Cardiology","Casualty","Central Analytical Laboratory","Central Animal House","Chest Medicine","Clinical Pharmacology","Community Medicine","Conservative & Operative","CVTS","CVTS OT","CVTS(LIC)","Dentistry","Dermatology","Dispensary","E Lab","ECG Dept","EMS- Casualty","EMS OT","EMS-Casualty","Endocrinology","ENT","ENT OT","ENT/Ophthal OT","ENT/Opthalmic Ward","Female Ward","FGW/FSW","FMW","Forensic Medicine & Toxicology","Gastroenterology","Gastroenterology & Surgical","General Surgery","Ground floor minor OT","Ground floor-Laboratory","Ground floor-Pathology","Ground floor-Store","Ground floor-X Ray","Gynaecology Operation Theatre","Gynecology OPD","Gynecology OT","Gynecology Ward","Haematology","Health Post","Histopathology","ICU","IPCU","J.J ICU","LABORATORY","Laboratory - 1st Floor","Laboratory - Ground floor","Labour Ward","Labour Ward - OPD","MAIN OT","Major OT","Male Surgery Ward","Male Ward","Malvani Maternity Home","Medicine","Medicine/ MICU","Microbiology","MICU","MICU/ICCU","Minor OT","NA","Neonatology","Nephrology","Neurosurgery","Neurosurgery Cart Room","Neurosurgery Cupbored","Neurosurgery ICU","Neurosurgery OT","Neurosurgery OT 1","Neurosurgery OT 2","Neurosurgery S.T.Cup","Neurosurgery S.T.Room","Neurosurgery Stereo Statit Room","NICU","NICU - 2nd Floor","NICU - 6th floor","Nuclear Medicine","O.T.P.T.","Observation Ward","Obstetrics & Gynecology","Occupational Therapy","Occupational Therapy and Physiotherapy","OPD","Operation Theater ENT OT","Operation Theature - Ophthalmology","Operation Threatre Orthopedics","Ophthalmology","Opthal OPD","Oral Pathology","Oral Surgery","Orthodontics","Orthopedics","OT","OT - 1ST floor","OT Gynec","Paediatric OPD - Ground floor","Paediatric Surgery","Paediatric Ward","Paediatrics","Pathology","PCR LAB","Pediatric Dentistry","Pediatrics (Hemat)","Periodontics","Pharmacology","Pharmacology & Therapeutics","Physiology","Physiotherapy","PICU","Plastic Surgery","PNC Ward","PNC Ward - 1st floor","PNC WARD-PNC WARD","Prosthetic","PSYCHIATRY","PU","PU/NICU","Public Health Dentisry","Pulmonary Medicine","Radiology","Radiology MICU","Recovery Room","Recovery WARD OT","SICU","Sonography OPD","SOT","Store","Store Room","Store-Store","Surgery O.T.","Telemedicine","Trauma ICU","Trauma O.T.","Urology","USG Department","Ward","Ward 14","X-Ray"];

class AdditionalReports extends Component {
	constructor(props) {
		super(props);
		this.state = {
			result : [],
			reportMapping : {
				'DMO Approved Document' : {
					name:'dmoapproveddocument'
				},
				'Penalty Record' : {
					name:'penaltyreport',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Order No",
						"key" : "servicecallno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Received Date",
						"key" : "servicecalldate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Received Time",
						"key" : "servicecalldate",
						"aliasekey" : "servicecalldatetime",
						"cellClass" : "text-center",
						"format" : "time",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Criticality",
						"key" : "criticality",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Goa','BMC BLR'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Completed Date",
						"key" : "completeddate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Completed Time",
						"key" : "completeddate",
						"aliasekey" : "completeddatetime",
						"cellClass" : "text-center",
						"format" : "time",
						"width" : 150
					},{
						"name" : "Workorder Status",
						"key" : "functionalstatus",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "DownTime in Days",
						"key" : "downtime",
						"cellClass" : "text-center",
						"format" : "numberonly",
						"width" : 150
					},{
						"name" : "Allowable DownTime",
						"key" : "allowabletime",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Penalty Applicable Days",
						"key" : "penaltyapplicabledays",
						"cellClass" : "text-center",
						"format" : "numberonly",
						"width" : 150
					},{
						"name" : "Equipment Cost",
						"key" : "equipmentcost",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150
					},{
						"name" : "Penalty Per Day (INR)",
						"key" : "penaltyperday",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150
					},{
						"name" : "Calculated Penalty",
						"key" : "calculatedpenalty",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 3 ? false : true)
					},{
						"name" : "Penalty Cap",
						"key" : "penaltycap",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 3 ? false : true)
					},{
						"name" : "Total Penalty",
						"key" : "totalpenalty",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150
					},{
						"name" : "Remarks",
						"key" : "remarks",
						"cellClass" : "text-center",
						"width" : 150
					}]
				},
				'Breakdown Report' : {
					name:'breakdownreport',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Order No",
						"key" : "servicecallno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Received Date",
						"key" : "servicecalldate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Received Time",
						"key" : "servicecalldate",
						"aliasekey" : "servicecalldatetime",
						"cellClass" : "text-center",
						"format" : "time",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Completed Date",
						"key" : "completeddate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Completed Time",
						"key" : "completeddate",
						"aliasekey" : "completeddatetime",
						"cellClass" : "text-center",
						"format" : "time",
						"width" : 150
					},{
						"name" : "Workorder Status",
						"key" : "functionalstatus",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "DownTime in Days",
						"key" : "downtime",
						"cellClass" : "text-center",
						"format" : "numberonly",
						"width" : 150
					}]
				},
				'Billed Equipment List' : {
					name : 'billedequipmentlist',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Manufacturer",
						"key" : "manufacturer",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Model No",
						"key" : "modelno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Serial No",
						"key" : "serialno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Department/Location",
						"key" : "department",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Mumbai' ,'Mumbai New','Tripura New','Arunachal Pradesh','Goa','BMC BLR'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "Functional Status",
						"key" : "functionalstatus",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Goa', 'BMC BLR', 'Mumbai New'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "Criticality",
						"key" : "criticality",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Goa', 'BMC BLR'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "Purchase Date",
						"key" : "purchasedate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Goa', 'BMC BLR'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "Equipment Cost",
						"key" : "cost",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150,
						"hidden" : ((this.props.app.companyid == 1 && ['Mizoram','Jharkhand','Tripura New','Arunachal Pradesh','Goa', 'BMC BLR'].includes(this.props.app.branch)) || this.props.app.companyid == 4 ? false : true)
					},{
						"name" : "PPM Done/Pending",
						"key" : "ppmstatus",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Mumbai New'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "Billed Amount(INR)",
						"key" : "billedamount",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150,
						"hidden" : true
					}]
				},
				'Preventive Maintenance Report' : {
					name : 'pmandcalibrationrecord',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Order No",
						"key" : "servicecallno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Order Date",
						"key" : "servicecalldate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "PM+CAL Status",
						"key" : "pmtype",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : true
					},{
						"name" : "Scheduled Month",
						"key" : "equipmentscheduledate_month",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Completed Date",
						"key" : "completeddate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Functional Status",
						"key" : "functionalstatus",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Status",
						"key" : "workstatus",
						"cellClass" : "text-center",
						"width" : 150
					}]
				},
				'Calibration Report' : {
					name : 'calibrationreport',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Order No",
						"key" : "servicecallno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Order Date",
						"key" : "servicecalldate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Scheduled Month",
						"key" : "equipmentscheduledate_month",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Completed Date",
						"key" : "completeddate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Functional Status",
						"key" : "functionalstatus",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Status",
						"key" : "workstatus",
						"cellClass" : "text-center",
						"width" : 150
					}]
				},
				'User Training' : {
					name : 'monthlyusertrainingreport',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Training Subject",
						"key" : "subject",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Department",
						"key" : "department",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Completed Date",
						"key" : "completeddate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "No. of Attendees",
						"key" : "noofattendees",
						"cellClass" : "text-center",
						"width" : 150
					}]
				} ,
				'List of Equipment Added for Billing' : {
					name : 'listofequipmentaddedforbilling',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Manufacturer",
						"key" : "manufacturer",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Model No",
						"key" : "modelno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Serial No",
						"key" : "serialno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Department/Location",
						"key" : "department",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "Equipment Cost",
						"key" : "cost",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150
					}]
				},
				'List of Equipment Removed from Billing' : {
					name : 'listofequipmentremovedforbilling',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Manufacturer",
						"key" : "manufacturer",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Model No",
						"key" : "modelno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Serial No",
						"key" : "serialno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Department/Location",
						"key" : "department",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "Equipment Cost",
						"key" : "cost",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150
					}]
				},
				'Equipment Proposed for Condemnation Report' : {
					name : 'equipmentproposedforcondemnationreport',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Manufacturer",
						"key" : "manufacturer",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Model No",
						"key" : "modelno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Serial No",
						"key" : "serialno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Department/Location",
						"key" : "department",
						"cellClass" : "text-center",
						"width" : 150,
						"hidden" : (this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? false : true)
					},{
						"name" : "Equipment Cost",
						"key" : "cost",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150
					}]
				},
				'Maintenance History' : {
					name : 'maintenancehistory',
					coldefArray : [{
						"name" : "Work Order No",
						"key" : "servicecallno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Call Receive Date and Time",
						"key" : "servicecalldate_datetime",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Call Complete Date and Time",
						"key" : "completeddate_datetime",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Functional Status",
						"key" : "callfunctionalstatus",
						"cellClass" : "text-center",
						"width" : 150
					}]
				}, 
				'Uptime Report' : {
					name:'uptimereport',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Order No",
						"key" : "servicecallno",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Call Date",
						"key" : "servicecalldate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Call Time",
						"key" : "servicecalldate",
						"aliasekey" : "servicecalldatetime",
						"cellClass" : "text-center",
						"format" : "time",
						"width" : 150
					},{
						"name" : "Completed Date",
						"key" : "completeddate",
						"cellClass" : "text-center",
						"format" : "date",
						"width" : 150
					},{
						"name" : "Completed Time",
						"key" : "completeddate",
						"aliasekey" : "completeddatetime",
						"cellClass" : "text-center",
						"format" : "time",
						"width" : 150
					},{
						"name" : "Functional Status",
						"key" : "functionalstatus",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Criticality",
						"key" : "criticality",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Down time (in Hours)",
						"key" : "downtime",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Allowable Time (in Hours)",
						"key" : "allowabletime",
						"cellClass" : "text-center",
						"width" : 250
					},{
						"name" : "Penalty Applicable in Hours",
						"key" : "penaltyapplicablehours",
						"cellClass" : "text-center",
						"width" : 250
					},{
						"name" :"Equipment Cost",
						"key" : "equipmentcost",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 150
					},{
						"name" : "CAMC Cost Per Quarter",
						"key" : "camccostquarter",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 250
					},{
						"name" : "Penaty/Day=0.5% * CAMC Quarter Amount",
						"key" : "penaltyperday",
						"cellClass" : "text-center",
						"format" : "number",
						"width" : 250
					},{
						"name" : "Total Penalty (Q*N)",
						"key" : "totalpenalty",
						"cellClass" : "text-center",
						"width" : 250
					},{
						"name" : "Maximum Penalty @10%",
						"key" : "maxpenalty",
						"cellClass" : "text-center",
						"width" : 250
					},{
						"name" : "Total Applicable Penalty",
						"key" : "totalapplicablepenalty",
						"cellClass" : "text-center",
						"width" : 250
					},{
						"name" : "Remarks",
						"key" : "description",
						"cellClass" : "text-center",
						"width" : 300
					}]
				},
				'Downtime Report' : {
					name:'downtimereport',
					coldefArray : [{
						"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
						"key" : "state",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Work Order No",
						"key" : "wono",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Received Date & Time",
						"key" : "receiveddate_datetime",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Hospital",
						"key" : "hospital",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Number",
						"key" : "menumber",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "ME Name",
						"key" : "mename",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Completed Date & Time",
						"key" : "completeddate_datetime",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Workorder Status",
						"key" : "status",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Functional Status",
						"key" : "functionalstatus",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Department",
						"key" : "department",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "DownTime in Days",
						"key" : "downtime",
						"cellClass" : "text-center",
						"width" : 150
					},{
						"name" : "Remarks",
						"key" : "description",
						"cellClass" : "text-center",
						"width" : 300
					}]
				}
			},
			reportname : null,
			showdate : false,
			showyear : false,
			showquarter : false,
			showterritory : false,
			showparentterritory : false,
			showfunctionalstatus : false,
			showdstate : false,
			daterangeformat : 'YQM',
			showhospital : false,
			showbarcode : null,
			showcalltype : null,
			showppmtype : null,
			showcontractstatus : false,
			showdepartment : false,
			showhospital : false,
			showhospitalcategory : false,
			
			result : [],
			state : null,
			fromdate : null,
			todate : null,
			year : null,
			quarter : null,
			territory : null,
			functionalstatus : null,
			barcode : null,
			calltype : 'PPM',
			ppmtype : 'PPM',
			contractstatus : null,
			department : null,
			partnerid : null,
			partnergroupid : null,

			daterequire : false,
			yearrequire : false,
			quarterrequire : false,
			territoryrequire : false,
			functionalstatusrequire : false,
			calltyperequire : false,
			ppmtyperequire : false,
			staterequire : false,
			contractstatusrequire : false,
			departmentrequire : false,
			hospitalrequire :false,
			hospitalcategoryrequire :false,
			barcoderequire : false,
			loaderflag : true
		};


		this.onload = this.onload.bind(this);
		this.reportOnChange = this.reportOnChange.bind(this);
		this.disableViewButton = this.disableViewButton.bind(this);
	}

	componentWillMount() {
		this.onload();

		setTimeout(()=>{
			this.updateWindowSize();
		}, 0);
	}

	disableViewButton(){
		let disable = false;
		if(!this.state.reportname) return true;

		if(this.state.reportname == 'Maintenance History' ){
			if(!this.state.barcode) disable =true;
		}

		if(this.state.daterequire && !(this.state.fromdate && this.state.todate)) disable =true;

		if(this.state.functionalstatusrequire && !this.state.functionalstatus) disable =true;

		if(this.state.contractstatusrequire && !this.state.contractstatus) disable =true;

		if(this.state.departmentrequire && !this.state.department) disable =true;

		if(this.state.calltyperequire && !this.state.calltype) disable =true;

		if(this.state.ppmtyperequire && !this.state.ppmtype) disable =true;

		if(this.state.barcoderequire && !this.state.barcode) disable =true;

		if(this.state.hospitalrequire && !this.state.partnerid) disable =true;

		if(this.state.hospitalcategoryrequire && !this.state.partnergroupid) disable =true;

		if(this.state.yearrequire && !this.state.year) disable =true;

		if(this.state.quarterrequire && !this.state.quarter) disable =true;

		if(this.state.territoryrequire && !this.state.territory) disable =true;

		if(this.state.reportname == 'Preventive Maintenance Report' ){
			if(!this.state.calltype) disable =true;
		}

		/*if(this.state.reportname == 'Penalty Record' ){
			if(!this.state.fromdate || !this.state.todate)
				disable =true;
		}*/

		return disable;
	}

	reportOnChange(value){
		let tempObj = {
			reportname : value,
			showdate : false,
			showyear : false,
			showquarter : false,
			showterritory : this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? false : true,
			showparentterritory : this.props.app.companyid == 1 && this.props.app.branch == 'Sysmex' ? true : false,
			daterangeformat : (this.props.app.companyid == 9 || this.props.app.companyid == 8 || this.props.app.companyid == 3 || (this.props.app.companyid == 1 &&  ['Mumbai New'].includes(this.props.app.branch)) ) ? 'YQ' : 'YQM',
			calltype : 'PPM',
			showfunctionalstatus : false,
			showcontractstatus : false,
			showdepartment : false,
			showdstate : false,
			showhospital :false,
			showhospitalcategory :false,
			showbarcode : false,
			showcalltype : false,
			showppmtype : false,
			daterequire : false,
			yearrequire : false,
			quarterrequire : false,
			territoryrequire : false,
			functionalstatusrequire : false,
			staterequire : false,
			hospitalrequire :false,
			barcoderequire : false,

			result : [],
			state : null,
			fromdate : null,
			todate : null,
			year : null,
			quarter : null,
			territory : null,
			functionalstatus : null,
			barcode : null,
			calltype : 'PPM',
			contractstatus : null,
			department : null,
			partnerid : null,
			partnergroupid : null,

			componentkey : uuid.v1()
		};

		if(value == 'DMO Approved Document'){
			tempObj.showquarter = true;
			tempObj.quarterrequire =true;
			tempObj.showterritory = false;
		}

		if(value == 'Billed Equipment List'){
			tempObj.showdate = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showdepartment = true;
		}

		if(value == 'List of Equipment Added for Billing'){
			tempObj.showdate = true;
			tempObj.showfunctionalstatus = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showcontractstatus = true;
			tempObj.showdepartment = true;
		}

		if(value == 'List of Equipment Removed from Billing'){
			tempObj.showdate = true;
			tempObj.showfunctionalstatus = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showcontractstatus = true;
			tempObj.showdepartment = true;
		}

		if(value == 'Equipment Proposed for Condemnation Report'){
			tempObj.showdate = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showcontractstatus = true;
			tempObj.showdepartment = true;
		}

		if(value == 'Maintenance History' ){
			tempObj.showbarcode = true;
			tempObj.barcoderequire = true;
			tempObj.showterritory = false;
		}

		if(value == 'Preventive Maintenance Report' ){
			tempObj.showdate = true;
			tempObj.showppmtype = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showcontractstatus = true;
			tempObj.showfunctionalstatus = true;

			tempObj.ppmtyperequire = true;
		}

		if(value == 'Calibration Report' ){
			tempObj.showdate = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showcontractstatus = true;
			tempObj.showfunctionalstatus = true;
		}

		if(value == 'User Training' ){
			tempObj.showdate = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showdepartment = true;
		}

		if(value == 'Penalty Record'){
			tempObj.showdate = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showcontractstatus = true;
		}

		if(value == 'Breakdown Report'){
			tempObj.showdate = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showparentterritory = true;
		}

		if(value == 'Uptime Report'){
			tempObj.showdate = true;
			tempObj.showhospital = true;
			tempObj.showhospitalcategory = true;
			tempObj.showfunctionalstatus = true;
			tempObj.showdepartment = true;
		}

		if(value == 'Downtime Report'){
			tempObj.showdate = true;
			tempObj.showparentterritory = true;
		}

		if(tempObj.showdate && !this.props.app.isDemoDashboard) tempObj.daterequire = true;

		this.setState({...tempObj});
	}

	generate(type){
		this.setState({loaderflag:true});
		let filterstring = '';
		if(this.state.fromdate && this.state.todate){
			filterstring += `&fromdate=${new Date(this.state.fromdate).toDateString()}&todate=${new Date(this.state.todate).toDateString()}`
		}

		if(this.state.functionalstatus)
			filterstring += `&functionalstatus=${this.state.functionalstatus}`;

		if(this.state.contractstatus)
			filterstring += `&contractstatus=${this.state.contractstatus}`;

		if(this.state.ppmtype)
			filterstring += `&ppmtype=${this.state.ppmtype}`;

		if(this.state.department)
			filterstring += `&department=${this.state.department}`;

		if(this.state.year)
			filterstring += `&year=${this.state.year}`;

		if(this.state.state)
			filterstring += `&state=${this.state.state}`;

		if(this.state.quarter)
			filterstring += `&quarter=${this.state.quarter}`;

		if(this.state.territory > 0)
			filterstring += `&territory=${this.state.territory}`;

		if(this.state.barcode)
			filterstring += `&barcode=${this.state.barcode}`;

		if(this.state.calltype)
			filterstring += `&calltype=${this.state.calltype}`;

		if(this.state.partnerid > 0)
			filterstring += `&partnerid=${this.state.partnerid}`;

		if(this.state.partnergroupid > 0)
			filterstring += `&partnergroupid=${this.state.partnergroupid}`;

		axios.get(`/api/additionalreports/${this.state.reportMapping[this.state.reportname].name}?type=${type}${filterstring}`).then((response) => {
			if (response.data.message == 'success') {
				this.setState({loaderflag:false,result : response.data.main});
				if(this.state.reportname == 'DMO Approved Document'){
					return null;
				}

				if(type == 'pdf'){
					var win = window.open("/print/"+response.data.filename+"?url=" + response.data.url, '_blank');
					if (!win) {
						this.props.openModal(modalService['infoMethod']({
							header : 'Warning',
							body : "Popup Blocker is enabled! Please add this site to your exception list.",
							btnName : ['Ok']
						}));
					}
				}else{
					generateExcel(this.state.reportname, this.state.reportMapping[this.state.reportname].coldefArray,response.data.main, () => {
						this.setState({loaderflag:false});
					});
				}
			} else {
				console.log(response);
			}
		});
	}

	onload(){
		this.setState({loaderflag:true});
		axios.get(`/api/additionalreports/authentications`).then((response) => {
			if (response.data.message == 'success') {
				this.setState({loaderflag:false});
			} else {
				console.log(response);
				//localStorage.setItem("pageafterlogin", window.location.hash.split('#')[1]);
				//window.location='/login';
			}
		});
	}

	componentDidMount () {
		setTimeout(() => {
			let table_header_width = document.getElementsByClassName('trimed-table_body') ? document.getElementsByClassName('trimed-table_body')[0].clientWidth : 0;
			this.setState({ table_header_width });
		}, 300);
		window.addEventListener('resize', this.updateWindowSize);
		
		/*setTimeout(()=>{
			this.updateWindowSize();
		}, 0);*/
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowSize);
	}

	updateWindowSize = () => {
		this.setState((prevState) => {
			return {
				duplicatereload: !prevState.duplicatereload
			}
		});
	}

	render() {

		let reportArray = [];

		if(this.props.app.companyid != 1 || this.props.app.branch != 'Sysmex') reportArray.push('Penalty Record');

		reportArray.push('Billed Equipment List' , 'Preventive Maintenance Report', 'Calibration Report' , 'User Training' ,'List of Equipment Added for Billing','List of Equipment Removed from Billing','Equipment Proposed for Condemnation Report','Maintenance History');

		if(this.props.app.companyid == 1 && this.props.app.branch == 'Sysmex') reportArray.push('Breakdown Report');

		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tata') reportArray.push('Downtime Report');

		if(this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch)) reportArray.push('Uptime Report');

		if(this.props.app.companyid == 3) reportArray.push('DMO Approved Document');

		let { result,reportname ,showdate, showyear, showquarter, showterritory, showparentterritory , showhospitalcategory, showhospital ,showfunctionalstatus, showcontractstatus, showdepartment ,showdstate , showbarcode , showcalltype, showppmtype, daterequire,yearrequire,quarterrequire,territoryrequire ,barcoderequire , functionalstatusrequire , contractstatusrequire, departmentrequire , hospitalrequire , hospitalcategoryrequire ,calltyperequire,ppmtyperequire , loaderflag,daterangeformat , componentkey} = this.state;
		
		let table_body_height = $(window).outerHeight() - $('.header').outerHeight() -$('.breakdown_call_title').outerHeight() - $('.breakdown_call_filter').outerHeight() - $('.gs-custom-tab').outerHeight() - $('.breakdown_call_table_header1').outerHeight() - $('.breakdown_call_table_header2').outerHeight() - $('.additionalreports_filter').outerHeight() - 120;

		
		let isTableHasScrollbar = $('.trimed_table_container').outerHeight() < $('.trimed-table_body').outerHeight() ? true : false;
		let tablebody_scrollWidth = $('.table_body_wrapper').outerWidth() - $('.trimed-table_body').outerWidth();

		isTableHasScrollbar = true;
		tablebody_scrollWidth = tablebody_scrollWidth == 0 ? 17 : tablebody_scrollWidth;

		return (
			<div className="row">
				<div className="col-lg-12 col-md-12">
					<Loadingcontainer isloading={loaderflag}></Loadingcontainer>
					<div className="row breakdown_call_title">
						<div className="col-lg-12 col-md-12" >
							<div className="d-flex flex-row justify-content-between margintop-10 marginbottom-10 card-details-header">
								<div>
									<div className="cursor-ptr" style={{color: "#FFFFFF",float: "left"}} onClick={()=>{this.props.history.push('/');}}>
										<div style={{float: "left",width: "25px",height: "25px",background: "#0EC98D",textAlign: "center",borderRadius: "2px 0px 0px 2px"}}>
											<img src="./images/home-btn-icon.svg"/>
										</div>
										<div style={{float: "left",width: "50px",height: "25px",background: "#11E4A1",borderRadius: "0px 2px 2px 0px",fontFamily: "Poppins",fontStyle: "normal",fontWeight: "600",fontSize: "13px",padding: "4px"}}>
											Home
										</div>
									</div>
								</div>

								<div className=" drilldown-header" style={{textAlign:"center",float:"left",fontFamily: "Poppins",fontStyle: "normal",fontSize:"20px"}}>
										Billing Reports
								</div>
								<div></div>
							</div>
						</div>
					</div>
					<div className="row additionalreports_filter" style={{padding: "20px" ,background:"white"}}>
						<div className="form-group col-lg-2 col-md-3">
							<LocalSelect placeholder={'Select Report'} name={'reportname'} options={reportArray} value={this.state.reportname} multiselect={false} required={true} onChange={(value)=>{this.reportOnChange(value);}}/>
						</div>
						{
							((this.props.app.companyid == 1 && this.props.app.branch == 'Sysmex') && showparentterritory) ?
								<div className="form-group col-lg-2 col-md-3">
									<SelectAsync key={componentkey} placeholder={"Select State"} resource="parentterritorysearch" fields="id,territoryname" label="territoryname" value={this.state.state} onChange={(value, valueobj) => {this.setState({state:value});}} />
								</div>
							 : null
						}
						{
							((this.props.app.companyid == 9 || this.props.app.companyid == 8 || this.props.app.companyid == 3 || (this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch))) && showdate && !this.props.app.isDemoDashboard) ?
								<div className="form-group col-lg-6 col-md-9">
									<DateRangeField key={componentkey} app={this.props.app} report={this.state.reportname} format={daterangeformat} onChange={(value)=>{this.setState({...value});}} />
								</div>
							 : null
						}
						{
							((this.props.app.companyid == 7 || this.props.app.companyid == 4 || (this.props.app.companyid == 1 && ['Jharkhand','Tata','Arunachal Pradesh','Tripura','Mizoram','Nagaland','Tripura New','Sysmex','Goa', 'BMC BLR'].includes(this.props.app.branch))) && showdate && !this.props.app.isDemoDashboard) ?
								<div className="form-group col-lg-2 col-md-3">
									<DateElement key={componentkey} app={this.props.app} placeholder={"Select From Date"} value={this.state.fromdate} required = {true} className={`form-control ${(!this.state.fromdate) ? 'errorinput' : ''}`} onChange={(value)=>{this.setState({fromdate : value});}} />
								</div>
							 : null
						}
						{
							((this.props.app.companyid == 7 || this.props.app.companyid == 4 || (this.props.app.companyid == 1 && ['Jharkhand','Tata','Arunachal Pradesh','Tripura','Mizoram','Nagaland','Tripura New','Sysmex','Goa', 'BMC BLR'].includes(this.props.app.branch))) && showdate && !this.props.app.isDemoDashboard) ?
								<div className="form-group col-lg-2 col-md-3">
									<DateElement key={componentkey} app={this.props.app} placeholder={"Select To Date"} value={this.state.todate} required = {true} className={`form-control ${(!this.state.todate) ? 'errorinput' : ''}`} onChange={(value)=>{this.setState({todate : value});}} />
								</div>
							 : null
						}
						{
							(showterritory) ?
								<div className="form-group col-lg-2 col-md-3">
									<SelectAsync key={componentkey} placeholder={"Select District"} className={`${(territoryrequire && !this.state.territory) ? 'errorinput' : ''}`} resource="territorysearch" fields="id,territoryname" label="territoryname" value={this.state.territory} onChange={(value, valueobj) => {this.setState({territory:value});}} required={true} />
								</div>
							 : null
						}
						{
							(showyear) ?
								<div className="form-group col-lg-2 col-md-3">
									<LocalSelect key={componentkey} placeholder={'Select Year'} className={`${(yearrequire && !this.state.year) ? 'errorinput' : ''}`} name={'year'} options={['Year1','Yesr2']} value={this.state.year} multiselect={false} required={true} onChange={(value)=>{this.setState({year:value})}}/>
								</div>
							 : null
						}
						{
							((this.props.app.companyid == 3) && showquarter) ?
								<div className="form-group col-lg-2 col-md-3">
									<LocalSelect key={componentkey} placeholder={'Select Quarter'} className={`${(quarterrequire && !this.state.quarter) ? 'errorinput' : ''}`} name={'quarter'} options={['Q1 (18-11-2019 to 17-02-2020)','Q2 (18-02-2020 to 17-05-2020)','Q3 (17-05-2020 to 18-08-2020)','Q4 (18-08-2020 to 17-11-2020)','Q1 (18-11-2020 to 17-02-2021)','Q2 (18-02-2021 to 17-05-2021)','Q3 (17-05-2021 to 18-08-2021)','Q4 (18-08-2021 to 17-11-2021)','Q1 (18-11-2021 to 17-02-2022)','Q2 (18-02-2022 to 17-05-2022)','Q3 (17-05-2022 to 18-08-2022)','Q4 (18-08-2022 to 17-11-2022)']} value={this.state.quarter} multiselect={false} required={true} onChange={(value)=>{this.setState({quarter:value})}}/>
								</div>
							 : null
						}
						{
							(showhospitalcategory) ?
								<div className="form-group col-lg-2 col-md-3">
									<SelectAsync key={componentkey} placeholder={"Select Hospital Category"} className={`${(hospitalcategoryrequire && !this.state.partnergroupid) ? 'errorinput' : ''}`} resource="customercategorysearch" fields="id,name" label="name" value={this.state.partnergroupid} onChange={(value, valueobj) => {this.setState({partnergroupid:value,partnerid:null,department:null});}} required={true} />
								</div>
							 : null
						}
						{
							(showhospital) ?
								<div className="form-group col-lg-2 col-md-3">
									<AutoSelect key={componentkey} placeholder={"Select Hospital"} className={`${(hospitalrequire && !this.state.partnerid) ? 'errorinput' : ''}`} resource="customersearch" resourceName="partners" filter={this.state.partnergroupid ? `partners.partnergroupid=${this.state.partnergroupid}` : ''} fields="id,name" label="name" value={this.state.partnerid} onChange={(value, valueobj) => {this.setState({partnerid:value,department:null});}} required={true} />
								</div>
							 : null
						}
						{
							(showfunctionalstatus) ?
								<div className="form-group col-lg-2 col-md-3">
									<LocalSelect key={componentkey} placeholder={'Select Functional Status'} className={`${(functionalstatusrequire && !this.state.functionalstatus) ? 'errorinput' : ''}`} name={'functionalstatus'} options={functionalstatusArray} value={this.state.functionalstatus} multiselect={false} required={true} onChange={(value)=>{this.setState({functionalstatus:value})}}/>
								</div>
							 : null
						}
						{
							(showcontractstatus) ?
								<div className="form-group col-lg-2 col-md-3">
									<LocalSelect key={componentkey} placeholder={'Select Contract Status'} className={`${(contractstatusrequire && !this.state.contractstatus) ? 'errorinput' : ''}`} name={'contractstatus'} options={contractstatusArray} value={this.state.contractstatus} multiselect={false} required={true} onChange={(value)=>{this.setState({contractstatus:value})}}/>
								</div>
							 : null
						}
						
						{
							(this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) && showdepartment) ?
								<div className="form-group col-lg-2 col-md-3">
									<AutoSuggest key={componentkey} placeholder={'Select Department'} className={`${(departmentrequire && !this.state.department) ? 'errorinput' : ''}`} name={'department'} value={this.state.department} resource = {'equipments'} field = {'zzzdepartment'} filter={this.state.partnerid ? `equipments.partnerid=${this.state.partnerid}` : ''} onChange={(value)=>{this.setState({department:value})}}/>
								</div>
							 : null
						}
						{
							(showppmtype) ?
								<div className="form-group col-lg-2 col-md-3">
									<LocalSelect key={componentkey} placeholder={'Select PPM Type'} className={`${(!this.state.ppmtype) ? 'errorinput' : ''}`} name={'ppmtype'} options={['PPM','Calibration']} value={this.state.ppmtype} multiselect={false} required={true} onChange={(value)=>{this.setState({ppmtype:value})}}/>
								</div>
							 : null
						}
						{
							(showbarcode) ?
								<div className="form-group col-lg-2 col-md-3">
									<input key={componentkey} type="text" className={`form-control ${(barcoderequire && !this.state.barcode) ? 'errorinput' : ''}`}  value={this.state.barcode} placeholder={'Equipment Barcode/ME Number'} onChange={(event)=>{this.setState({barcode:event.target.value})}} required={true} autoComplete="off" ></input>
								</div>
							 : null
						}
						{
							(reportname) ?
								<div className="form-group col-lg-1 col-md-1">
									<button type="button" className="btn btn-sm btn-primary" onClick={()=>{this.generate('pdf');}} disabled={this.disableViewButton()}>{(reportname != 'DMO Approved Document') ? 'View PDF' : 'View'}</button>
								</div> 
							: null
						}
						{
							(reportname && reportname != 'DMO Approved Document') ?
								<div className="form-group col-lg-1 col-md-1">
									<button type="button" className="btn btn-sm btn-primary" onClick={()=>{this.generate('excel');}} disabled={this.disableViewButton()}>Export Excel</button>
								</div> 
							: null
						}
					</div>
					<div className="row">
						{
							(this.state.reportname == 'DMO Approved Document' && result && result.length > 0) ?
								<div className="col-lg-12 col-md-12" style={{backgroundColor: '#fff'}}>
									
										<div className="row no-gutters" style={{padding: '20px'}}>
												<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 trimed_table_container">
													<div className="trimed-table-wrapper" ref="listheader" style={{width: `${isTableHasScrollbar && tablebody_scrollWidth > 1 ? `calc(100% - ${tablebody_scrollWidth}px)` : '100%'}`}}>
														<table className="table table-bordered trimed-table">
															<colgroup>
																<col style={{width: '30%'}} />
																<col style={{width: '30%'}} />
															</colgroup>
															<thead>
																<tr>
																	<th className="text-center table-header">District</th>
																	<th className="text-center table-header">Document</th>
																</tr>
															</thead>
														</table>
													</div>
													<div className="table_body_wrapper" ref={this.listbodyRef} style={{width: '100%', position: 'relative', height: `${table_body_height}px`, maxHeight: `${table_body_height}px`, overflow: 'auto'}}>
														<table className="table table-hover table-bordered trimed-table trimed-table_body">
															<colgroup>
																<col style={{width: '30%'}} />
																<col style={{width: '30%'}} />
															</colgroup>
															<thead>
																<tr>
																	<th className="text-center table-header">District</th>
																	<th className="text-center table-header">Document</th>
																</tr>
															</thead>
															<tbody>
																{result.map((item, key) => {
																	return <tr key={key}>
																		<td className="text-center table-content">{item.territoryname}</td>
																		
																		<td className="text-center table-content">
																			{
																				(item.fileurl) ? <a role="button" className="btn btn-sm btn-default" style={{color: "#444",background: "#D3D3D3"}} href={item.fileurl} data-toggle="tooltip" title={item.territoryname} target="_blank">View</a> : null
																			}
																		</td>
																		
																	</tr>
																})}
															</tbody>
														</table>
													</div>
												</div>
											</div>
										
								</div> 
							: null
						}
						
					</div>
				</div>
			</div>
		);
	}
}

AdditionalReports = connect(
	(state, props) => {
		let formName = 'additionalreports';

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateAppState, updateComponentState }
)(reduxForm()(AdditionalReports));

export default AdditionalReports;


// WEBPACK FOOTER //
// ./public/react/components/additionalreports.js